module.exports = __webpack_public_path__ + "img/pic_coinstore_x3value@3x.123b7f9b.png";